import { Spin } from 'antd';
import { useCallback, useMemo } from 'react';

import { useNavigate } from '@suntex.core/nav';
import { PageMetadata } from '@suntex.fim/framework';
import { StagesOfLearningProgress } from '@suntex.fim/hub';

import { useNavigationContext } from '../NavigationContext';
import { useModuleAccess, usePlayer, usePlayerProgressSummary } from '../hooks';
import { useModuleNavigation } from '../navigation';
import { getPlayerGradeLevel } from '../utils/focus';

export function StagesOfLearningProgressPage({
  getHubHref,
}: {
  getHubHref: (path: string) => string;
}) {
  const { isModuleEnabled, moduleTagging, isLoading } = useModuleAccess();
  const progressSummary = usePlayerProgressSummary();
  const { isPreview, playerInfo } = usePlayer();
  const { previewModulesPath } = useNavigationContext();
  const { navigateToModule } = useModuleNavigation();
  const navigate = useNavigate();

  const config = useMemo(
    () => ({ preview: isPreview, previewModulesPath }),
    [isPreview, previewModulesPath],
  );
  const onNavigate = useCallback(
    (link: { kind: 'module' | 'hub'; href: string }) => {
      if (link.kind === 'module') {
        navigateToModule(link.href);
      } else {
        navigate(link.href);
      }
    },
    [navigate, navigateToModule],
  );

  if (isLoading || !moduleTagging) return <Spin />;

  return (
    <>
      <PageMetadata title="Stages of Learning" />
      <h1>Stages of Learning</h1>
      <StagesOfLearningProgress
        config={config}
        isModuleEnabled={isModuleEnabled}
        gradeLevel={getPlayerGradeLevel(playerInfo)}
        progressSummary={progressSummary}
        moduleTagging={moduleTagging}
        getHubHref={getHubHref}
        onNavigate={onNavigate}
      />
    </>
  );
}
